// ── useLogger hook ──────────────────────────────────────────────────────────
// Returns an MFE-scoped Logger from the ObservabilityProvider context.

import { useObservability } from './ObservabilityProvider';

/**
 * Returns the structured Logger for the current MFE scope.
 *
 * The logger has `mfeName`, `orgId`, `orgSlug`, and `workspaceId`
 * automatically bound as context fields.
 */
export function useLogger() {
  const {
    logger
  } = useObservability();
  return logger;
}